<div class="container-fluid" *ngIf="isCheckingUrl || isValidUrl">
  <div class="row" role="banner" aria-label="Header" *ngIf="headerHtml">
    <div class="text-center" [innerHtml]="headerHtml"></div>
  </div>

  <div role="region" aria-label="progressBarLabel" class="container" *ngIf="showProgressBar">
    <div class="HmsContainer">
      <div class="row HmsInsideContainer mb40" >
          <div class="wd-20">
            <span class="col-sm-6 numberStyle pull-left" [ngStyle]="{'background-color': submitPartyBgColor, 'color': submitPartyNumColor}">1</span>
            <span class="col-sm-6 pull-left textStyle" [ngStyle]="{'color': submitPartyColor}">Submitting Party Information</span>
          </div>
          <div class="wd-20  ds-flex">
            <p class="line col-sm-3 pull-left" [ngStyle]="{'border-color': referralLineColor}"></p>
            <span class="col-sm-4 numberStyle pull-left" [ngStyle]="{'background-color': referralBgColor, 'color': referralNumColor}">2</span>
            <span class="col-sm-5 pull-left textStyle" [ngStyle]="{'color': referralColor}">Referral Details</span>
          </div>
          <div class="wd-20 ds-flex">
            <p class="line col-sm-3 pull-left" [ngStyle]="{'border-color': involvedPartyLineColor}"></p>
            <span class="col-sm-4 numberStyle pull-left" [ngStyle]="{'background-color': involvedPartyBgColor, 'color': involvedPartyNumColor}">3</span>
            <span class="col-sm-5 pull-left textStyle" [ngStyle]="{'color': involvedPartyColor}">Involved Parties</span>
          </div>
          <div class="wd-20 ds-flex">
            <p class="line col-sm-3 pull-left" [ngStyle]="{'border-color': questionLineColor}"></p>
            <span class="col-sm-4 numberStyle pull-left" [ngStyle]="{'background-color': questionBgColor, 'color': questionNumColor}">4</span>
            <span class="col-sm-5 pull-left ln-ht-40 textStyle" [ngStyle]="{'color': questionColor}">Questions</span>
          </div>
          <div class="wd-20 ds-flex">
            <p class="line col-sm-3 pull-left" [ngStyle]="{'border-color': submitReferralLineColor}"></p>
            <span class="col-sm-4 numberStyle pull-left" [ngStyle]="{'background-color': submitReferralBgColor, 'color': submitReferralNumColor}">5</span>
            <span class="col-sm-5 pull-left textStyle" [ngStyle]="{'color': submitReferralColor}">Submit Referral</span>
          </div>
      </div>
    </div>
  </div>
  
  <router-outlet (activate)="setHeader()"></router-outlet>
</div>

<div class="centered-text" *ngIf="!isCheckingUrl && !isValidUrl">
  <h1>Incomplete URL. Please verify the web address that you are attempting to access.</h1>
</div>
